import React from "react";
import {Link} from "react-router-dom";

function PageNotFound() {
    return (
        <section style={{textAlign: 'center'}}>
            <h3>Страница не найдена</h3>
            <p>Вернуться на <Link to={`/`}>главную страницу</Link></p>
        </section>
    );
}

export default PageNotFound;
